import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit'
import { getAuthenticatedUser, logoutUser, refreshToken } from './authApi'

const initialState = {
    user: null,
    isAuthenticated: null,
    isLoading: false,
    error: null,
    expireAt: null,
}

export const getAuthUser = createAsyncThunk('auth/user', async (arg, thunkAPI) => {
    try {
        const response = await getAuthenticatedUser()
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const logout = createAsyncThunk('auth/logout', async (arg, thunkAPI) => {
    try {
        const response = await logoutUser()
        window.localStorage.removeItem('exp')
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const refresh = createAsyncThunk('auth/refresh', async (arg, thunkAPI) => {
    try {
        const response = await refreshToken()
        window.localStorage.setItem('exp', response.data.data.exp)
        return response.data
    } catch (error) {
        window.localStorage.removeItem('exp')
        return thunkAPI.rejectWithValue(error)
    }
})

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        unAuthenticate: state => {
            state.isAuthenticated = false
            state.user = null
            state.expireAt = null
        },
        tokenize: (state, { payload }) => {
            state.expireAt = payload
        },
    },
    extraReducers: builder => {
        builder.addCase(getAuthUser.pending, (state, { payload }) => {
            state.isLoading = true
        })
        builder.addCase(getAuthUser.fulfilled, (state, { payload }) => {
            state.isAuthenticated = true
            state.user = payload.data
            state.isLoading = false
        })
        builder.addCase(getAuthUser.rejected, (state, action) => {
            state.isAuthenticated = false
            state.user = null
            state.expireAt = null
            state.isLoading = false
            state.error = action.payload.errorMessage
        })
        builder.addCase(logout.fulfilled, state => {
            state.isAuthenticated = false
            state.user = null
            state.expireAt = null
        })
        builder.addCase(logout.rejected, state => {
            state.error = 'Something went wrong! Unable to logout'
        })
        builder.addCase(refresh.fulfilled, (state, { payload }) => {
            state.expireAt = payload.data.exp
        })
    },
})

export const { unAuthenticate, tokenize } = authSlice.actions

export default authSlice.reducer

export const isAuth = state => state.auth.isAuthenticated
export const expireAt = state => state.auth.expireAt
export const isLoading = state => state.auth.isLoading
export const currentUser = state => state.auth.user

export const isAuthorizedUser = createSelector(
    currentUser,
    user => user?.agreementId !== '00000000-0000-0000-0000-000000000000'
)
export const privileges = createSelector(currentUser, user => user?.privileges)
